module.exports = __webpack_public_path__ + "static/img/公司团建@2x (1).e33220e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/公司团建@2x (1).png
// module id = r1KO
// module chunks = 1